import styles from "./header.module.scss";

import DetailedBox from "../DetailedBox";
import { useContext, useEffect } from "react";
import { Context } from "../../App";
import axios from "axios";

export default function Header() {
  const { setAddress, setData, address} = useContext(Context);

  const handleChange = (e) => {
    setAddress(e.target.value);
  };

  const getRequest = () => {
    axios
      .get(
        `https://geo.ipify.org/api/v2/country,city?apiKey=${process.env.REACT_APP_API_KEY}&ipAddress=${address}`,
      )
      .then((res) => setData(res.data))
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    axios
      .get(
        `https://geo.ipify.org/api/v2/country,city?apiKey=${process.env.REACT_APP_API_KEY}&ipAddress=8.8.8.8`,
      )
      .then((res) => setData(res.data));
  }, []);

  return (
    <header>
      <h1>IP Address Tracker</h1>
      <div className={styles.input_wrapper}>
        <input
          type="text"
          placeholder="Search for any IP address or domain"
          onChange={(e) => handleChange(e)}
        />
        <div onClick={() => getRequest()}>
          <svg
            width="13"
            height="20"
            viewBox="0 0 13 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2 2L10.5091 10.2909L2 18.5818"
              stroke="white"
              stroke-width="3"
            />
          </svg>
        </div>
      </div>
      <DetailedBox />
    </header>
  );
}
